<template>
    <div>
        <div :class="$style['apply-refund-message']">
            <table>
                <pt-form-list-item label="发货状态">
                    <div style="color:red;font-size:14px;display:inline">
                        {{isShiped?'已发货':'未发货'}}
                        </div>
                </pt-form-list-item>
                <pt-form-list-item :label="titleLable+'渠道'" :required="true">
                    <wt-radio :radios="refundChannels" v-model="form.refundChannel"  data-vv-as="退还渠道"  name="refundChannel"  v-validate="'required'" :disabled="!isSelectRefundChannel"></wt-radio>
                </pt-form-list-item>
                <pt-form-list-item label="收货状态" :required="true">
                    <template>
                        <wt-radio :radios="sendGoods"  :disabled="!isShiped" v-model="form.receiveCase"   data-vv-as="收货状态"  name="isGot"  v-validate="'required'" ></wt-radio>
                   </template>
                </pt-form-list-item>
                 <pt-form-list-item :label="titleLable+'方式'" :required="true">
                   <wt-radio :radios="title?refundmentType:refundmentTypeIntegral"  :disabled="!isShiped" v-model="form.refundmentType" data-vv-as="退还方式"  name="refundmentType"  v-validate="'required'"></wt-radio>
                </pt-form-list-item>
                <template v-if="needCourier">
                    <pt-form-list-item label="快递公司：">
                        <wt-selector v-model="courier_id" data-vv-as="快递公司" :class="$style['sample-type-select']" :options="expressesList"  name="courierName"
                        :props="expressesProp" :allow-create="true" :filterable="true" :clearable="true" placeholder="请输入或选择"></wt-selector>
                    </pt-form-list-item>
                    <pt-form-list-item label="快递单号：">
                        <wt-input v-model="form.courierNumber"  data-vv-as="快递单号"  name="courierNumber" ></wt-input>
                    </pt-form-list-item>
                    </template>
                <pt-form-list-item label="取消实验室订单" v-if="samplesList&&samplesList.length">
                    <template>
                    <wt-checkbox :checkList="samplesList" labelName="sampleId" v-model="form.sampleIds" style="line-height:40px"></wt-checkbox>
                    <div style="font-size:13px;color:red">如商城订单确认全部或部分退款，请选择要取消的实验室检测任务的样本ID，否则实验室将继续实验并产生不必要的成本。</div>
                    </template>
                </pt-form-list-item>
                <pt-form-list-item :label="title?titleLable+'金额':titleLable" :required="true">
                   <wt-input :class="$style['number-input-price']" v-model="form.show_amount"  data-vv-as="退还金额"  v-validate="'required|decimal:2|morezero'"  name="refundmentType"  @blur="refundAmountBlur"  v-if="title">
                       <el-button slot="append">¥</el-button></wt-input>
                   <wt-input :class="$style['number-input-price']" v-model="form.amount"  data-vv-as="退还金额"  v-validate="'required|decimal:2|morezero'"  name="refundmentType"  @blur="refundAmountBlur"  v-else></wt-input>
                </pt-form-list-item>
                <pt-form-list-item :label="titleLable+'原因'">
                   <wt-selector v-model="form.reason" :options="refundReasonList" :allow-create="true" :props="refundReasonProps" :loading="refundReasonLoading"
                   filterable :defaultFirstOption="false"  :clearable="true" placeholder="请输入或选择" @visible-change="visibleChange"></wt-selector>
                </pt-form-list-item>
                <pt-form-list-item :label="titleLable+'说明'">
                   <wt-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" v-model="form.remark"></wt-input>
                </pt-form-list-item>
                <pt-form-list-item label="上传凭证" >
                   <template>
                <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
                 :multiple="false" v-model="form.credential">
                    <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
                </wt-upload-file>
                <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：800*800像素；建议分辨率：120dpi；图片格式：.jpg、.npg,可上传多张图片</div>
                </template>
                </pt-form-list-item>
            </table>
        </div>
        <div>
            <el-button type="primary" @click="submit" :loading="loading">申请{{titleLable}}</el-button>
            <el-button type="primary" plain v-if="isApplyAgain" @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import { refundmentType, refundmentTypeIntegral } from 'json/goods-order-options'
import { refundReturns, onlyRefund, sendGoods, refundChannel } from '../goods-order-options.js'
import { cashCount } from '@/utils/formUtils'
import emitter from '@/mixins/emitter'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins, emitter],
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    refundReasonList: {
      type: Array,
      default: function () {
        return []
      }
    },
    againApplyDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    refundReasonLoading: {
      type: Boolean,
      default: false
    },
    isApplyAgain: {
      type: Boolean,
      default: false
    },
    // true 文字为退款  false 为退还积分
    title: {
      type: Boolean,
      default: true
    },
    userPoints: Number,
    specifications: Object
  },
  data () {
    return {
      form: JSON.parse(JSON.stringify(this.againApplyDetail)),
      refundmentType: refundmentType,
      refundmentTypeIntegral: refundmentTypeIntegral,
      privateResourcesUrl: this.$privateResourcesUrl,
      uploadApi: this.$uploadApi,
      refundReturnsOptions: refundReturns,
      onlyRefundOptions: onlyRefund,
      sendGoods: sendGoods,
      refundChannels: refundChannel,
      picture_params: {
        resourceName: 'mallorders'
      },
      expressesProp: {
        label: 'name',
        value: 'id'
      },
      loading: false,
      refundReasonProps: {
        label: 'name',
        value: 'id'
      },
      courier_id: this.againApplyDetail.courierId,
      expressesList: []
    }
  },
  computed: {
    samplesList () {
      return (this.orderDetail && this.orderDetail.expressDetails && this.orderDetail.expressDetails.samples) || null
    },
    // 是否需要快递信息
    needCourier () {
      return (this.form.refundmentType === 'MONEY_AND_GOODS' && this.form.receiveCase === 'RECEIVED') || (this.form.refundmentType === 'POINTS_AND_GOODS' && this.form.receiveCase === 'RECEIVED')
    },
    // 是否已发货
    isShiped () {
      return this.orderDetail && this.orderDetail.expressDetails
    },
    // 是否需要发货
    isShippingMode () {
      return this.orderDetail.goods && this.orderDetail.goods[0] && this.orderDetail.goods[0].shippingMode !== 'NONE'
    },
    // 是否需要选择退款渠道
    isSelectRefundChannel () {
      return false
    },
    titleLable () {
      return this.title ? '退款' : '退还积分'
    },
    goodsRewardPoints () {
      return (this.specifications && this.specifications.rewardPoint) || 0
    }
  },
  watch: {
    againApplyDetail: {
      handler: function (val) {
        this.form = JSON.parse(JSON.stringify(val))
        this.courier_id = val.courierId
      },
      deep: true
    },
    courier_id: {
      handler: function (val) {
        let isAdd = false
        if (this.expressesList.length >= 0) {
          isAdd = true
          this.expressesList.forEach(item => {
            if (item.id === val) {
              this.form.courierId = val
              this.form.courierName = item.name
              isAdd = false
            }
          })
        }
        if (isAdd && val) {
          this.createExporess(val)
        }
      }
    },
    orderDetail: {
      handler: function (val) {
        if (val.id) {
          this.picture_params.objectId = val.id
          if (val.orderStatus === 'PAID' || val.orderStatus === 'PAYING' || (val.orderStatus === 'WAITING_FOR_PAYMENT' && val.isBalanceWaitingPayment) || !this.isShippingMode || val.status === 'DELIVERY') {
            if (this.title) {
              this.$set(this.form, 'refundmentType', 'MONEY')
            } else {
              this.$set(this.form, 'refundmentType', 'POINTS')
            }
            this.$set(this.form, 'receiveCase', 'NOT_RECEIVED')
            // this.form.refundmentType = 'MONEY'
            // this.form.receiveCase = 'NOT_RECEIVED'
            // this.form.refundChannel = 'RETURN_PLACED_WAY'
          }
          this.$set(this.form, 'refundChannel', 'RETURN_PLACED_WAY')
        }
      },
      deep: true,
      immediate: true
    },
    'form.reason': {
      handler: function (val) {
        let isAdd
        if (this.refundReasonList.length >= 0) {
          isAdd = true
          this.refundReasonList.forEach(item => {
            if (item.id === val) {
              isAdd = false
            }
          })
        }
        if (isAdd && val) {
          this.createRefundReson(val)
        }
      }
    }
  },
  methods: {
    createExporess (val) {
      let data = {
        name: val
      }
      this.$store.dispatch('createExporess', data).then(res => {
        this.$message.success('新建快递公司成功')
      }).catch(err => {
        this.$message.error(err || '新建快递公司失败')
      })
    },
    cancel () {
      this.$emit('cancel')
    },
    getExpresses () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getExpresses', data).then(res => {
        this.expressesList = res
      }).catch(err => {
        this.$message.error(err || '获取快递公司数据失败')
      })
    },
    visibleChange () {
      this.$emit('getRefundmentReason')
    },
    refundAmountBlur (val) {
      val = parseFloat(val)
      let contrastVal = this.title ? this.orderDetail.payment_total : (this.orderDetail.paymentSummary && this.orderDetail.paymentSummary.total)
      if (val > contrastVal) {
        let message = this.title ? '退款金额不能大于订单支付的金额' + this.orderDetail.payment_total + '元' : '退还积分额度不能大于订单兑换的积分额度' + (this.orderDetail.paymentSummary && this.orderDetail.paymentSummary.total) + '分'
        this.$message.error(message)
        setTimeout(_ => {
          if (this.title) {
            this.$set(this.form, 'show_amount', null)
          } else {
            this.$set(this.form, 'amount', null)
          }
        })
      }
    },
    createRefundReson (val) {
      let data = {
        name: val,
        type: 'RefundmentReason',
        value: val
      }
      let ajaxUrl = this.title ? 'newRefundmentReason' : 'newIntegralRefundmentReason'
      this.$store.dispatch(ajaxUrl, data).then(res => {
        this.$message.success('新建' + this.titleLable + '原因成功')
      }).catch(err => {
        this.$message.error(err || '创建' + this.titleLable + '原因失败')
      })
    },
    submit () {
      if (this.title) {
        this.form.amount = cashCount(this.form.show_amount)
      }
      this.refundReasonList.forEach(item => {
        if (item.id === this.form.reason) {
          this.form.reasonDescription = item.name
        }
      })
      if (this.title) {
        if (this.goodsRewardPoints > this.userPoints) {
          return this.$confirm(`当前用户积分(${this.userPoints})不足已抵扣对应商品的奖励积分(${this.goodsRewardPoints}),
        若继续退款，将扣除用户的剩余积分，请确认是否继续退款操作`, '退款确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            setTimeout(_ => {
              this.validate('form').then(formValue => {
                this.applyForRefundment(formValue)
              })
            }, 500)
          }).catch(_ => {

          })
        } else {
          this.validate('form').then(formValue => {
            this.applyForRefundment(formValue)
          })
        }
      } else {
        this.validate('form').then(formValue => {
          this.applyForRefundment(formValue)
        })
      }
    },
    applyForRefundment (val) {
      let data = {
        mallOrderId: this.orderDetail.id,
        refundmentApply: val
      }
      let integralData = {
        pointsOrderId: this.orderDetail.id,
        apply: val
      }
      this.loading = true
      let ajaxUrl = this.title ? 'applyForRefundment' : 'getApplyRefundPoints'
      let param = this.title ? data : integralData
      this.$store.dispatch(ajaxUrl, param).then(res => {
        this.loading = false
        this.$message.success('申请' + this.titleLable + '成功')
        if (this.title) {
          this.dispatch('pt-order-detail', 'goodsOrderDetail')
        } else {
          if (this.isApplyAgain) {
            history.go(-1)
          } else {
            this.dispatch('pt-integral-exchange-detail', 'getIntegralDetail')
          }
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '申请' + this.titleLable + '失败')
      })
    }
  },
  created () {
    this.getExpresses()
  }
}
</script>
<style module lang="less">
.apply-refund-message{
    max-width: 500px;
    padding: 0 20px;
    :global
    table{
        tr{
            td{
                padding-bottom: 10px;
            }
        }
    }
}
.number-input-price{
    max-width: 260px;
}
</style>
